import { Accordion, AccordionProps } from 'ui';

export const LearnMoreCardAccordion = (props: AccordionProps) => {
  return (
    <Accordion {...props}>
      <Accordion.Item value="item_1">
        <Accordion.Control>We Never Store Your Credit Card Information</Accordion.Control>
        <Accordion.Panel>
          Givebacks does not receive or store your bank account, payment card, or online payment
          service credentials on any systems that we operate.
          <br />
          <br />
          Learn more about how we keep this information safe.{' '}
          <a
            className="text-teal-100 mt-[8px] block"
            target="_blank"
            href={
              'https://support.givebacks.com/hc/en-us/articles/15303355814679-Is-Shop-to-Give-safe-What-does-it-do-with-my-data'
            }
            rel="noreferrer"
          >
            Read More
          </a>
        </Accordion.Panel>
      </Accordion.Item>

      <Accordion.Item value="item_2">
        <Accordion.Control>We Will Never Sell Your Data</Accordion.Control>
        <Accordion.Panel>
          Givebacks is committed to your privacy. We will never sell any of your data to businesses
          or third parties. Ever.
        </Accordion.Panel>
      </Accordion.Item>

      <Accordion.Item value="item_3">
        <Accordion.Control>We Have Bank-Level Security</Accordion.Control>
        <Accordion.Panel>
          Givebacks uses industry standard AES-256 encryption algorithm to encrypt your data and
          make sure your private data stays private.
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};
